import { useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  removeAuthErrors,
  trialRegisterUser,
} from '../../redux/actions/AuthActions'
import { toast } from 'react-toastify'
import { getTotalSubscriptionPlusMembers } from '../../utils/Helper'

const ReviewConfirm = ({
  activeCycle,
  paymentTypeText,
  currentPlan,
  show,
  registerFormData,
  billingMemberCount,
}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {
    auth: { registerError, signUpLoading },
  } = useSelector((state) => state)

  const signUp = useCallback(() => {
    dispatch(trialRegisterUser(registerFormData, history))
  }, [registerFormData])

  useEffect(() => {
    if (registerError) {
      toast.dismiss()
      toast.error(registerError)

      dispatch(removeAuthErrors())
    }
  }, [registerError])

  return (
    <div
      className="tikbox-review-confirm tikbox-container"
      style={{ display: show ? 'block' : 'none' }}>
      <div className="tikbox-review-confirm__content">
        <h2>Review & Confirm</h2>
        <p className="description">
          Let's make sure everything looks correct.{' '}
          {activeCycle !== 3 && 'You can cancel your trial before it ends.'}
        </p>
        <div className="tikbox-price-summary">
          <div className="tikbox-item">
            <span>{currentPlan?.name}</span>
            <span>
              {activeCycle === 1
                ? paymentTypeText.cycleOne
                : paymentTypeText.cycleTwo}
              <br />{' '}
              {billingMemberCount ? `${billingMemberCount} member(s)` : ''}
            </span>
            <span>
              {activeCycle === 1
                ? currentPlan?.priceAnnually &&
                  getTotalSubscriptionPlusMembers(
                    currentPlan?.priceAnnually,
                    billingMemberCount,
                  )
                : activeCycle === 2
                ? currentPlan?.priceMonthly &&
                  getTotalSubscriptionPlusMembers(
                    currentPlan?.priceMonthly,
                    billingMemberCount,
                  )
                : ''}
            </span>
          </div>
          <br />
          <div className="tikbox-confirm">
            <button onClick={signUp} disabled={signUpLoading}>
              Complete Order{' '}
              {signUpLoading && (
                <FontAwesomeIcon className="spinner" icon={faSpinner} />
              )}
            </button>
          </div>
          <p className="further-desc">
            {`Your subscription will automatically renew ${
              activeCycle === 1 ? 'annually' : 'each month'
            }.`}{' '}
            By completing this purchase you agree to our{' '}
            <a
              href="https://web.tikbox.com/terms-conditions/"
              target="_blank"
              rel="noreferrer">
              Terms Of Service
            </a>{' '}
            and{' '}
            <a
              href="https://web.tikbox.com/privacy-policy/"
              target="_blank"
              rel="noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  )
}

export default ReviewConfirm
